export const navMenu = [
  // {
  //   id: 1,
  //   menuTitle: "공지/이벤트",
  //   url: "/notificationevent",
  // },
  {
    id: 2,
    menuTitle: "내 운송기록",
    url: "/mydrive-list",
  },
  {
    id: 3,
    menuTitle: "차량 등록 관리",
    url: "/carmanagement",
  },
  // {
  //   id: 4,
  //   menuTitle: "알림 설정",
  //   url: "/Alarmoption",
  // },
  {
    id: 5,
    menuTitle: "약관 및 정책",
    url: "/agreement",
  },
  {
    id: 6,
    menuTitle: "개인정보 처리방침",
    url: "/personalInformationProcessingPolicy",
  },
];
